<template>
  <div class="modal lp-speedbump"
       id="dxfOffsiteModal"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div v-html="messageHtml"></div>
        </div>
        <div class="modal-footer border-0">
          <a :href="modalUrl"
             :target="modalTarget"
             class="btn btn-primary btn-round offsite-link me-3"
             @click="closeModal">{{proceedButtonText}}</a>
          <button type="button"
                  class="btn btn-outline-primary btn-round"
                  data-dismiss="modal"
                  @click="closeModal">
            {{stayButtonText}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop lp-speedbump-backdrop" v-if="backdrop"></div>
</template>
<script lang="ts">
  import { onMounted, reactive, ref, toRef } from 'vue';
  import Modal from 'bootstrap/js/dist/modal';
  import { decodeHtml } from '../helpers/html';

  export default {
    name: 'SpeedBump',
    props: {
      backdrop: {
        type: Boolean,
        default: true,
      },
      message: {
        type: String,
        required: true,
      },
      urls: {
        type: Array,
        required: true,
      },
      proceedButtonText: {
        type: String,
        required: true,
      },
      stayButtonText: {
        type: String,
        required: true,
      },
    },
    setup(props: any) {
      const messageHtml = ref(decodeHtml(props.message));
      const modalUrl = ref('');
      const modalTarget = ref('')
      let dxfOffsiteElement: HTMLElement | null | undefined;
      let dxfOffsiteModal: Modal | null | undefined;
      let modalBackdrop: Element | null | undefined;
      const urlArray = reactive(props.urls.map((url: any) => url));

      const openModal = () => {
        if (dxfOffsiteModal) {
          dxfOffsiteModal.show();

          if (modalBackdrop) {
            modalBackdrop.classList.add('show');
          }
        }
      };
      const closeModal = () => {
        if (dxfOffsiteModal) {
          dxfOffsiteModal.hide();

          if (modalBackdrop) {
            modalBackdrop.classList.remove('show');
          }
        }
      };

      const watchLink = (event: MouseEvent) => {
        const self = event.currentTarget as HTMLAnchorElement;
        if (self) {
          const url = self.getAttribute('href');
          const target = self.getAttribute('target')
          modalTarget.value = target;

          // eslint-disable-next-line no-script-url
          if (
            url &&
            !url.startsWith('#') &&
            !url.includes('javascript:') &&
            !self.classList.contains('offsite-link') &&
            !url.includes('tel:') &&
            !url.includes('mailto:')
          ) {
            if (self.host !== window.location.host) {
              const safe = urlArray.some((u: any) => url.includes(u));

              if (dxfOffsiteModal && !safe) {
                event.preventDefault();

                modalUrl.value = url;
                openModal();
              }
            } 

          }
        }
      };

      const initCloseButtons = () => {
        if (dxfOffsiteElement) {
          const closeButton = dxfOffsiteElement.querySelector('.lp-speedbump__close');
          const proceedButton = dxfOffsiteElement.querySelector(
            '.lp-speedbump__proceed',
          );

          if (closeButton) {
            closeButton.addEventListener('click', closeModal);
          }

          if (proceedButton) {
            proceedButton.addEventListener('click', closeModal);
          }
        }
      };

      onMounted(() => {
        dxfOffsiteElement = document.getElementById('dxfOffsiteModal');
        const speedbumpModalOptions: Modal.Options = {
          backdrop: false,
          focus: true,
          keyboard: true,
        };
        if (dxfOffsiteElement) {
          dxfOffsiteModal = new Modal(dxfOffsiteElement, speedbumpModalOptions);
          modalBackdrop = document.querySelector('.lp-speedbump-backdrop');

          const pageLinks = document.querySelectorAll('a');
          pageLinks.forEach((link) => {
            link.addEventListener('click', watchLink);
          });

          initCloseButtons();
        }
      });

      return { closeModal, messageHtml, modalUrl, modalTarget };
    },
  };
</script>
